import { BasePlacement, ComputedPlacement } from '@popperjs/core'

const basePlacements = ['top', 'bottom', 'left', 'right']

const getOppositePlacement = (placement: BasePlacement): BasePlacement => {
  switch (placement) {
    case 'left':
      return 'right'
    case 'right':
      return 'left'

    case 'bottom':
      return 'top'
    case 'top':
    default:
      return 'bottom'
  }
}

export const getFallbackPlacement = (placement: ComputedPlacement) => {
  const [basePlacement, variationPlacement] = placement.split('-')
  const oppositePlacement = getOppositePlacement(basePlacement as BasePlacement)
  const otherPlacements = basePlacements.filter(p => p !== oppositePlacement)

  return [`${oppositePlacement}${variationPlacement ? `-${variationPlacement}` : ''}`, ...otherPlacements]
}
